import React from "react";
import { Helmet } from "react-helmet-async";
import "@/App.css";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import FounderNoteSection from "./components/FounderNoteSection";
import TeamSection from "./components/TeamSection";
import ProgramsSection from "./components/ProgramsSection";
import ExpertConversationsSection from "./components/ExpertConversationsSection";
import VideoTestimonialsSection from "./components/VideoTestimonialsSection";
import TestimonialsSection from "./components/TestimonialsSection";
import ContactSection from "./components/ContactSection";
import GoogleReviewsSection from "./components/GoogleReviewsSection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";
import FoodImageStrip from "./components/FoodImageStrip";
import AIChatWidget from "./components/AIChatWidget";

function App() {
  return (
    <div className="App bg-bone" data-testid="app">
      <Helmet>
        <title>Fitly India | World-Class Fertility & Hormonal Wellness Clinic</title>
        <meta name="description" content="Fitly India - World-class fertility nutrition and hormonal wellness clinic. Expert doctors and nutritionists helping achieve natural pregnancies, PCOS management, IVF support, and holistic wellness." />
        <link rel="canonical" href="https://fitlyindia.org" />
      </Helmet>
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <FounderNoteSection />
        <TeamSection />
        <ProgramsSection />
        <VideoTestimonialsSection />
        <TestimonialsSection />
        <GoogleReviewsSection />
        <ExpertConversationsSection />
        <FoodImageStrip variant="light" />
        <ContactSection />
      </main>
      <FAQSection />
      <Footer />
      <AIChatWidget />
    </div>
  );
}

export default App;
